import type { Setter } from 'solid-js'
import { modifyMutable, produce } from 'solid-js/store'
import Unexpected from '../../Exception/Unexpected.class'
import type { Engine } from '../engine/Engine.type'
import createSampleEntity from '../entity/createSampleEntity'
import type { EntityId } from '../entity/EntityId.type'
import { createDesertEntity } from '../entity/EntityType/Desert'
import { createPlainEntity } from '../entity/EntityType/Plain'
import { createSeaEntity } from '../entity/EntityType/Sea'
import { createSnowEntity } from '../entity/EntityType/Snow'
import type { EntityTypeId } from '../entity/EntityTypeId.enum'
import entityTypeMetaList from '../entity/entityTypeMetaList.generated'
import findByIdOrThrow from '../findByIdOrThrow'
import tmpRngWith from '../rng/tmpRngWith'
import type { State } from '../state/State.type'
import { randomId } from '../util/rand'
import { BiomeTypeId } from './BiomeTypeId.enum'

const width = 5
const height = 5

export default function updateArmyPainterBiome(
  engine: Engine,
  biomeId: BiomeTypeId,
  entityTypeId: EntityTypeId,
  setUnitId: Setter<EntityId>,
) {
  // console.log('updateArmyPainterBiome')
  modifyMutable(engine, produce((engine) => {
    const { state } = engine
    state.width = width
    state.height = height

    let id = 1

    const player = state.players[0]

    const playerId = player.id

    const ents: State['ents'] = []

    const rng = tmpRngWith(Math.random())

    const nextId = () => randomId(ents, rng)

    const createBiomeEnt = (() => {
      if (biomeId === BiomeTypeId.Snow) {
        return createSnowEntity
      }
      if (biomeId === BiomeTypeId.Plains) {
        return createPlainEntity
      }
      if (biomeId === BiomeTypeId.Desert) {
        return createDesertEntity
      }
      throw new Unexpected('Invalid biomeId')
    })()

    for (let x = 0; x < width; x++) {
      for (let y = 0; y < height; y++) {
        if (x + y < 6) {
          const ent = createBiomeEnt(id++, x, y)
          // console.log('ent', deepClone(ent))
          ents.push(ent)
        } else {
          ents.push(createSeaEntity(id++, x, y))
        }
      }
    }
    // console.log('ents', deepClone(ents))

    // ents.push(createMountainEntity(id++, 0, 0))

    // ents.push(createMountainEntity(id++, 1, 0))
    // ents.push(createMountainEntity(id++, 2, 0))
    // ents.push(createMountainEntity(id++, 3, 0))
    // ents.push(createMountainEntity(id++, 4, 0))

    // ents.push(createMountainEntity(id++, 0, 1))
    // ents.push(createMountainEntity(id++, 0, 2))
    // ents.push(createMountainEntity(id++, 0, 3))
    // ents.push(createMountainEntity(id++, 0, 4))

    // ents.push(createMountainEntity(id++, 1, 1))
    // // ents.push(createMountainEntity(id++, 1, 2))
    // // ents.push(createMountainEntity(id++, 2, 1))

    const entityMeta = findByIdOrThrow(entityTypeMetaList, entityTypeId)
    const unitId = nextId()
    setUnitId(unitId)
    const unitEnt = createSampleEntity(entityMeta.id, playerId, unitId)
    unitEnt.x = unitEnt.y = 2
    ents.push(unitEnt)

    // console.log('ents', deepClone(ents))

    state.ents = ents
  }))
}
